import { createOptions } from '@unmapped/core/filters/options';
export const CemeteryOperator = createOptions(['diocese', 'Diocesan Operated Cemeteries'], ['other', 'Parish Operated Cemeteries']);